var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.454,
    height: 20.967,
    viewBox: "0 0 29.454 20.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(-211.217 -247.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(212 248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-eye-3836167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M119.679,102.472c-.16-.368-4.023-9.142-13.124-9.142s-12.964,8.775-13.124,9.142a1.2,1.2,0,0,0,0,.947c.16.368,4.023,9.142,13.124,9.142s12.964-8.774,13.124-9.142h0a1.2,1.2,0,0,0,0-.947Zm-13.124,7.685c-6.491,0-9.816-5.516-10.685-7.212.871-1.666,4.253-7.212,10.685-7.212,6.483,0,9.814,5.512,10.685,7.212C116.367,104.612,112.988,110.158,106.555,110.158Z",
    transform: "translate(-93.333 -93.33)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M261.476,186.67a4.808,4.808,0,1,0,3.4,1.408A4.808,4.808,0,0,0,261.476,186.67Zm0,7.212a2.4,2.4,0,1,1,1.7-.7A2.4,2.4,0,0,1,261.476,193.882Z",
    transform: "translate(-248.254 -181.862)",
    fill: "#a0a0a0"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 26.675,
    y2: 18.188,
    transform: "translate(212.606 248.606)",
    fill: "none",
    stroke: "#a0a0a0",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/pass-icon.df77b13d3c6ef2c01d43974244b25a71.svg";
export { ForwardRef as ReactComponent };